import {Autocomplete, Pane, SearchInput, TextInput, TextInputField} from "evergreen-ui";
import React from "react";

export function AutoCompleteConstructor(
    onSelectStation,
    constructor,
    idx,
    stations,
    isFullInfo,
    createFullStationNameWithOuterIdx,
    createFullStationName
) {
    return <Autocomplete
        onSelect={selectedItem => onSelectStation(selectedItem)}
        initialInputValue={createFullStationNameWithOuterIdx(constructor.station, idx)}
        items={stations.map(createFullStationName).sort()}
        selectedItem={createFullStationNameWithOuterIdx(constructor.station, idx)}
    >
        {({
              key,
              getInputProps,
              getRef,
              inputValue,
              openMenu,
          }) => (
            <Pane key={key} ref={getRef} display="flex" >
                <SearchInput
                    flex="1"
                    placeholder="Введите название станции"
                    width={220}
                    value={createFullStationNameWithOuterIdx(constructor.station, idx)}
                    ref={getRef}
                    disabled={isFullInfo}
                    onFocus={openMenu}
                    {...getInputProps()}
                />
            </Pane>
        )}
    </Autocomplete>
}